'use client';

import dayjs from 'dayjs';
import React, { useState } from 'react';

import IconButton from '@mui/material/IconButton';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
  Box,
  Chip,
  Stack,
  Paper,
  Select,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  FormControl,
  Autocomplete,
} from '@mui/material';

import Iconify from '../../../../../components/iconify';
import Scrollbar from '../../../../../components/scrollbar';
import { useResponsive } from '../../../../../hooks/use-responsive';

const agents = ['Javison Simon', "McDonald's", 'Petr Ivanov'];
const activities = ['Rosh Hashana', 'UX', 'Html'];
const tags = ['Fast food', 'Complex Menu'];
const conditions = ['Payment at', 'Click on', 'Visit page'];
const comparators = ['=', '!=', '>', '<'];
const targets = ['site/app', 'email', 'dashboard'];

type Props = {
  close: () => void;
};

const RuleView = ({ close }: Props) => {
  const isMobile = useResponsive('down', 'sm');
  const [agentList, setAgentList] = useState<any>([]);
  const [activityList, setActivityList] = useState<any>([]);
  const [tagList, setTagList] = useState<any>([]);
  const [condition, setCondition] = useState('');
  const [comparator, setComparator] = useState('=');
  const [target, setTarget] = useState('');
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());

  return (
    <Paper sx={{ borderRadius: 3, height: '80vh' }}>
      <Box sx={{ position: 'absolute', top: 5, right: 5 }}>
        <IconButton onClick={() => close()}>
          <Iconify icon="material-symbols:close-rounded" />
        </IconButton>
      </Box>
      <Scrollbar sx={{ height: '80vh' }}>
        <Stack spacing={4}>
          <Stack direction="row" justifyContent="space-between" sx={{ cursor: 'pointer' }}>
            <Typography variant="h6">The Rule View</Typography>
          </Stack>
          <TextField fullWidth label="Rule Name" defaultValue="Rule One" />
          <TextField fullWidth label="Description (Optional)" multiline rows={2} />
          <Autocomplete
            multiple
            options={agents}
            value={agentList}
            onChange={(e, newValue) => setAgentList(newValue)}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  label={option}
                  color="secondary"
                  variant="filled"
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => <TextField {...params} label="Assigned Agent" />}
          />
          <TextField fullWidth label="SMB Account" defaultValue="Hilan" />
          <Autocomplete
            multiple
            options={activities}
            value={activityList}
            onChange={(e, newValue) => setActivityList(newValue)}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip label={option} color="info" variant="filled" {...getTagProps({ index })} />
              ))
            }
            renderInput={(params) => <TextField {...params} label="Activity (Optional)" />}
          />
          <Autocomplete
            multiple
            options={tags}
            value={tagList}
            onChange={(e, newValue) => setTagList(newValue)}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip label={option} color="success" variant="filled" {...getTagProps({ index })} />
              ))
            }
            renderInput={(params) => <TextField {...params} label="Tags" />}
          />
          Added Conditions
          <Stack direction="row" spacing={2} alignItems="center">
            <FormControl fullWidth>
              <InputLabel>Condition</InputLabel>
              <Select
                value={condition}
                onChange={(e) => setCondition(e.target.value)}
                label="Condition"
              >
                {conditions.map((c) => (
                  <MenuItem key={c} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Comparator</InputLabel>
              <Select
                value={comparator}
                onChange={(e) => setComparator(e.target.value)}
                label="Comparator"
              >
                {comparators.map((c) => (
                  <MenuItem key={c} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Target</InputLabel>
              <Select value={target} onChange={(e) => setTarget(e.target.value)} label="Target">
                {targets.map((t) => (
                  <MenuItem key={t} value={t}>
                    {t}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <TextField fullWidth label="Description (Optional)" multiline rows={2} />
          Validity Period
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack direction={isMobile ? 'column' : 'row'} gap={1}>
              <DateTimePicker
                label="Start Date"
                value={startDate}
                // onChange={(newValue) => setStartDate(newValue)}
              />
              <DateTimePicker
                label="End Date"
                value={endDate}
                // onChange={(newValue) => setEndDate(newValue)}
              />
            </Stack>
          </LocalizationProvider>
        </Stack>
      </Scrollbar>
    </Paper>
  );
};

export default RuleView;
